import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { AuthActions } from '../../store';
import { Footer } from '../Footer/Footer';
import './ForgotPassword.css';

const logo = require('../Login/assets/login-logo.png');

export class ForgotPassword extends Component {
  state = { email: '' };

  componentWillUnmount() {
    this.props.clearForgotPasswordMessages();
  }

  updateEmail(e) {
    const email = e.target.value;

    this.setState((state) => ({
      ...state,
      email,
    }));
  }

  forgotPassword(e) {
    e.preventDefault();
    const { email } = this.state;
    if (email) {
      this.props.forgotPassword(email);
    } else {
      this.props.setForgotPasswordError('Email cannot be blank.');
    }
  }

  renderForgotPasswordForm() {
    const { email } = this.state;
    const { forgotPasswordError } = this.props;

    // set error message visibility depending on state
    let forgotMessageClasses = 'forgot-password__message';
    forgotMessageClasses += this.props.forgotPasswordError ? ' forgot-password__message--error' : '';

    return (
      <div className="forgot-password-fields">
        <div className="forgot-password__title">Forgot your password?</div>
        <div className="forgot-password__text">
          Enter your email address below, and we&apos;ll send a link for resetting your password.
        </div>
        <form onSubmit={(e) => this.forgotPassword(e)} className="forgot-password-form">
          <input
            className="forgot-password__input"
            value={email}
            onChange={(e) => this.updateEmail(e)}
            type="email"
            id="email"
            name="email"
            placeholder="Enter your email"
          />
          <div className={forgotMessageClasses}>{forgotPasswordError}</div>
          <button type="submit" className="forgot-password__button">
            Send email
          </button>
        </form>
        <Link to="/login" className="forgot-password__login">
          &lt; Back to login
        </Link>
      </div>
    );
  }

  renderForgotPasswordEmailSent() {
    const { forgotPasswordMessage } = this.props;
    return (
      <div className="forgot-password-fields">
        <div className="forgot-password__title">Email sent successfully.</div>
        <div className="forgot-password__text">{forgotPasswordMessage}</div>
        <Link to="/login" className="forgot-password__login">
          &lt; Back to login
        </Link>
      </div>
    );
  }

  render() {
    const { forgotPasswordMessage, forgotPasswordError } = this.props;
    return (
      <div className="forgot-password">
        <div className="forgot-password-content">
          <div className="forgot-password-logo-wrapper">
            <img className="forgot-password__logo" src={logo} alt="Parity" />
          </div>
          <div className="forgot-password-fields-wrapper">
            {forgotPasswordMessage && !forgotPasswordError
              ? this.renderForgotPasswordEmailSent()
              : this.renderForgotPasswordForm()}
          </div>
        </div>
        <Footer light={true} />
      </div>
    );
  }
}

ForgotPassword.propTypes = {
  forgotPasswordMessage: PropTypes.string,
  forgotPasswordError: PropTypes.string,
  forgotPassword: PropTypes.func.isRequired,
  setForgotPasswordError: PropTypes.func.isRequired,
  clearForgotPasswordMessages: PropTypes.func.isRequired,
};

ForgotPassword.defaultProps = {
  forgotPasswordMessage: undefined,
  forgotPasswordError: undefined,
};

export function mapStateToProps(state) {
  return {
    forgotPasswordMessage: state.forgotPasswordReducer.forgotPasswordMessage,
    forgotPasswordError: state.forgotPasswordReducer.forgotPasswordError,
  };
}

const mapDispatchToProps = {
  forgotPassword: AuthActions.forgotPassword,
  setForgotPasswordError: AuthActions.setForgotPasswordError,
  clearForgotPasswordMessages: AuthActions.clearForgotPasswordMessages,
};

const ConnectedForgotPassword = connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
export { ConnectedForgotPassword };
